import { useSelector } from "react-redux";
import { getTemplate } from "../../reducers/templates";
import Template from "../templates/Template";

const TemplatePreview = (props) => {
    const template = useSelector(getTemplate);
    return <Template template={template} />;
};

export default TemplatePreview;